export interface ApiV2Response<T> {
  message?: string;
  status: 'success' | 'error';
  data: T;
}

export interface ListResponse<T> {
  data: T[];
  status: string;
  first_page_url: string;
  from: number;
  last_page: number;
  last_page_url: string;
  next_page_url: string;
  path: string;
  per_page: number;
  prev_page_url: string;
  to: number;
  total: number;
  current_page?: number;
  links?: {
    url: string | null;
    label: string;
    active: boolean;
  }[];
  totals?: {
    total_hours: number | null;
    total_pay: number | null;
  };
}

export interface ListParameters {
  per_page?: number;
  page?: number;
  search?: string;
  status?: string;
  contract?: string;
  type?: string;
  role?: string;
  location_id?: number | string;
  cache?: boolean;
  [key: string]: string | number | boolean | number[] | string[] | undefined;
}
